import React from 'react';
import { Container } from 'react-bootstrap';

import { Event } from '../../interfaces';
import { ErrorBoundary } from '../atoms';
import { EventDetails } from './EventDetails';

interface Props {
  event: Event;
}

export function EventTabs(props: Props) {
  const { event } = props;
  return (
    <Container fluid style={{ padding: 0 }}>

      <ErrorBoundary>
        <EventDetails event={event} />
      </ErrorBoundary>

    </Container>
  );
}
